import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Modal, message } from 'antd'
import MyInput from '../../../components/forms/input'
import MyImageUpload from '../../../components/forms/imageUpload'
import MyRadio from '../../../components/forms/radio'
import MyTextArea from '../../../components/forms/textArea'
import MySwitch from '../../../components/forms/switch'

const EditWebsiteNavigation = (props) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [formValue, setFormValue] = useState({})
  const [errorMsg, setErrorMsg] = useState({})

  useEffect(() => {
    axios.post('/p/deco/navigation/detail/get', {
      merchant_oid: merchantOid,
      navigation_oid: props.data.oid
    })
      .then(function (response) {
        if (response.errcode === 0) {
          const { mode, path, ...rest } = response.data;
          if (mode === 4) {
            setFormValue({ ...rest, mode, path, finderUserName: path });
          } else if (mode === 5 && path) {
            const [finderUserName, feedId] = path.split('&');
            setFormValue({ ...rest, mode, path, finderUserName, feedId });
          } else {
            setFormValue(response.data);
          }
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }, [merchantOid, props.data])

  const handleOk = () => {
    setErrorMsg({})
    if (!formValue.icon) {
      setErrorMsg({iconEmpty: '图标不能为空'})
      return false
    }

    let path
    if (formValue.mode === 4) {
      path = formValue.finderUserName
    } else if (formValue.mode === 5) {
      path = formValue.finderUserName + '&' + formValue.feedId
    } else {
      path = formValue.path
    }

    axios.post('/p/deco/navigation/edit', { 
      merchant_oid: merchantOid,
      navigation_oid: formValue.oid,
      name: formValue.name,
      icon: formValue.icon,
      mode: formValue.mode,
      is_hide: formValue.is_hide,
      path: path,
      sort: Number(formValue.sort)
    })
      .then(function (response) {
        if (response.errcode === 0) {
          handleCancel()
          props.getNavigationList()
          message.success('金刚位修改成功！')
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  const handleCancel = () => {
    setErrorMsg({})
    props.isCancel()
  }

  return (
    <Modal 
      title='编辑金刚位'
      destroyOnClose={true}
      width='760px'
      open={props.isOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      cancelText="取消"
      okText="保存">

      <MyImageUpload 
        id="icon"
        required
        label='图片'
        value={formValue.icon}
        setValue={setFormValue}
        errorMsg={errorMsg.iconEmpty}
      />

      <MyInput
        id="name"
        autoFocus
        maxLength={64}
        label='标题'
        placeholder='请输入金刚位的名称'
        value={formValue.name}
        onChange={setFormValue}
      />

      <MyRadio
        id='mode'
        label='跳转页面'
        options={[
          {
            label: '内部路径',
            value: 1,
          },
          {
            label: '外部网页',
            value: 2,
          },
          {
            label: '不跳转',
            value: 0,
          }
        ]}
        value={formValue.mode}
        onChange={setFormValue}
      />

      {[1, 2].includes(formValue.mode) && <MyTextArea 
        id="path"
        minRows={2}
        placeholder='请输入地址'
        value={formValue.path}
        onChange={setFormValue}
      />}

      <MySwitch 
        id='is_hide'
        label='是否隐藏'
        checked={formValue.is_hide}
        onChange={setFormValue}
      />

      <MyInput
        type='number'
        id="sort"
        label='排序'
        value={formValue.sort}
        onChange={setFormValue}
        styles={{ width: '60px' }}
        min={0}
        max={1000}
      />
    </Modal>
  )
}

export default EditWebsiteNavigation
